



import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { SelectLigDroits } from "../../redux/actions/GetLigDroits";
import "./FeuilleAcces.css";

// 🔹 Ligne
const Row = ({ code, label, rights, toggle }) => (
  <tr>
    <td>{label}</td>
    {["cons", "cre", "mdf", "sup"].map((field) => (
      <td key={field}>
        <input
          type="checkbox"
          checked={rights[code]?.[field] || false}
          onChange={() => toggle(code, field)}
        />
      </td>
    ))}
  </tr>
);

// 🔹 Header
const Header = () => (
  <thead>
    <tr>
      <th>Menu</th>
      <th>Cons</th>
      <th>Cre</th>
      <th>Mdf</th>
      <th>Sup</th>
    </tr>
  </thead>
);

const UserAcces = ({ ligdroits, SelectLigDroits, ConfigDossier , onClose}) => {
  const [rights, setRights] = useState({});
  const [groupe, setGroupe] = useState("");
  const [dossier, setDossier] = useState("");
  const [loading, setLoading] = useState(false);

  // 🔹 Chargement initial
  useEffect(() => {
    if (ConfigDossier) {
      SelectLigDroits(
        ConfigDossier.coddos,
        ConfigDossier.serveur,
        ConfigDossier.utilisateur,
        ConfigDossier.pwd_serveur,
        ConfigDossier.database,
        ""
      );
    }
  }, [ConfigDossier]);

  // 🔹 Mapping
  useEffect(() => {
    if (Array.isArray(ligdroits)) {
      const map = {};

      ligdroits.forEach((d) => {
        if (!d.coddr) return;

        map[d.coddr] = {
          cons: !!d.cons,
          cre: !!d.ajt,
          mdf: !!d.mdf,
          sup: !!d.sup,
        };
      });

      setRights(map);
    }
  }, [ligdroits]);

  // 🔹 Toggle
  const toggle = (code, field) => {
    setRights((prev) => ({
      ...prev,
      [code]: {
        ...prev[code],
        [field]: !prev[code]?.[field],
      },
    }));
  };

  // 🔹 Cocher tout
  const checkAll = () => {
    const updated = {};
    Object.keys(rights).forEach((k) => {
      updated[k] = { cons: true, cre: true, mdf: true, sup: true };
    });
    setRights(updated);
  };

  // 🔹 Décocher tout
  const uncheckAll = () => {
    const updated = {};
    Object.keys(rights).forEach((k) => {
      updated[k] = { cons: false, cre: false, mdf: false, sup: false };
    });
    setRights(updated);
  };

  // 🔹 Réorganiser (reset)
  const resetRights = () => {
    setRights({});
  };
  // 🔹 Charger données avec filtre
  const loadData = () => {
    if (!ConfigDossier) return;

    SelectLigDroits(
      groupe,
      dossier || ConfigDossier.coddos,
      ConfigDossier.serveur,
      ConfigDossier.utilisateur,
      ConfigDossier.pwd_serveur,
      ConfigDossier.database,
      
    );
  };

  // 🔹 UPDATE API
  const handleSubmit = async () => {
    if (!ConfigDossier) return;

    setLoading(true);

    try {
      const url = `https://www.24-crm.tn/webservice/api/Droits/UpdateLigDroits/?coddos=${encodeURIComponent(ConfigDossier.coddos)}&serveur=${encodeURIComponent(ConfigDossier.serveur)}&user=${encodeURIComponent(ConfigDossier.utilisateur)}&pwd=${encodeURIComponent(ConfigDossier.pwd_serveur)}&database=psdossier`;

      for (const d of ligdroits) {
        const data = {
          cons: !!rights[d.coddr]?.cons,
          ajt: !!rights[d.coddr]?.cre,
          mdf: !!rights[d.coddr]?.mdf,
          sup: !!rights[d.coddr]?.sup,
          ann: false,
          mdfnjours: 5,
          coddr: d.coddr,
          codgrp: d.codgrp,
          coddos: d.coddos,
        };

        await fetch(url, {
          method: "Post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
      }

      alert("✅ Enregistré !");
      loadData(); // 🔥 recharge après save
    } catch (err) {
      console.error(err);
      alert("❌ erreur serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    
    <div className="acces-container">
    <div className="header">
     <h3
        style={{
          color: "#001f7f",
          fontWeight: 600,
          letterSpacing: "1px",
        }} >Feuille des Accès</h3>
      
        <button onClick={onClose} style={{marginright: "10px",background: "darkred"}}>✕</button>
      </div>
      {/* 🔹 FILTRES */}
      <div style={{ display: "flex", gap: "15px", marginBottom: "10px" }}>
        {/* <div>
          <label>Groupe</label>
          <input
            value={groupe}
            onChange={(e) => setGroupe(e.target.value)}
          />
        </div> */}
<div>
  <label>Groupe</label>
  <select
    value={groupe}
    onChange={(e) => setGroupe(e.target.value)}
  >
    <option value="">-- Choisir --</option>
    <option value="200">200</option>
    <option value="300">300</option>
    <option value="400">400</option>
  </select>
</div>
<div>
  <label>Dossier</label>
  <input
    value={ConfigDossier?.coddos || ""}
    disabled
  />
</div>
        
      </div>
      <div className="table-wrapper">
      {/* 🔹 TABLE */}
      <table>
        <Header />
        <tbody>
          {ligdroits?.length > 0 ? (
            ligdroits.map((d) => (
              <Row
                key={d.coddr}
                code={d.coddr}
                label={d.lib || d.coddr}
                rights={rights}
                toggle={toggle}
              />
            ))
          ) : (
            <tr>
              <td colSpan="5">❌ Aucune donnée</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
    
     {/* 🔹 ACTIONS */}
     <div className="actions">
     <button onClick={loadData} className="btn info">
          Charger
        </button>

        <button onClick={handleSubmit} className="btn primary">
          {loading ? "Enregistrement..." : "Confirmer"}
        </button>
       <button onClick={checkAll} className="btn success">
           Cocher Tous 
        </button>

        <button onClick={uncheckAll} className="btn warning">
          Décocher Tous 
       </button>

        {/* <button onClick={resetRights} className="btn info">
          Réorganiser Tous 
       </button> */}

        {/* <button className="btn primary">Ajouter Accès</button> */}
      </div>
     </div>
    
  );
};

// 🔹 Redux
const mapStateToProps = (state) => ({
  ligdroits: state.ligdroits?.data || [],
  ConfigDossier: state.ConfigDossier,
});

const mapDispatchToProps = (dispatch) => ({
  SelectLigDroits: (g,a, b, c, d, e, f) =>
    dispatch(SelectLigDroits(g,a, b, c, d, e, f)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserAcces);

// import { connect } from "react-redux";
// import { SelectLigDroits } from "../../redux/actions/GetLigDroits";
// import "./FeuilleAcces.css";

// // 🔹 Ligne
// const Row = ({ code, label, rights, toggle }) => (
//   <tr>
//     <td>{label}</td>
//     {["cons", "cre", "mdf", "sup"].map((field) => (
//       <td key={field}>
//         <input
//           type="checkbox"
//           checked={rights[code]?.[field] || false}
//           onChange={() => toggle(code, field)}
//         />
//       </td>
//     ))}
//   </tr>
// );

// // 🔹 Header
// const Header = () => (
//   <thead>
//     <tr>
//       <th>Menu</th>
//       <th>Cons</th>
//       <th>Cre</th>
//       <th>Mdf</th>
//       <th>Sup</th>
//     </tr>
//   </thead>
// );

// const UserAcces = ({ ligdroits, SelectLigDroits, ConfigDossier }) => {
//   const [rights, setRights] = useState({});
//   const [groupe, setGroupe] = useState("");
//   const [dossier, setDossier] = useState("");

//   // 🔹 API call
//   useEffect(() => {
//     if (ConfigDossier) {
//       SelectLigDroits(
//         ConfigDossier.coddos,
//         ConfigDossier.serveur,
//         ConfigDossier.utilisateur,
//         ConfigDossier.pwd_serveur,
//         ConfigDossier.database
//       );
//     }
//   }, [ConfigDossier, SelectLigDroits]);

//   // 🔹 Mapping data
//   useEffect(() => {
//     if (Array.isArray(ligdroits)) {
//       const newRights = {};

//       ligdroits.forEach((d) => {
//         if (!d.coddr) return;

//         newRights[d.coddr] = {
//           cons: !!d.cons,
//           cre: !!d.ajt,
//           mdf: !!d.mdf,
//           sup: !!d.sup,
//         };
//       });

//       setRights(newRights);
//     }
//   }, [ligdroits]);

//   // 🔹 Toggle
//   const toggle = (code, field) => {
//     setRights((prev) => ({
//       ...prev,
//       [code]: {
//         ...prev[code],
//         [field]: !prev[code]?.[field],
//       },
//     }));
//   };

//   // 🔹 Cocher tout
//   const checkAll = () => {
//     const updated = {};
//     Object.keys(rights).forEach((k) => {
//       updated[k] = { cons: true, cre: true, mdf: true, sup: true };
//     });
//     setRights(updated);
//   };

//   // 🔹 Décocher tout
//   const uncheckAll = () => {
//     const updated = {};
//     Object.keys(rights).forEach((k) => {
//       updated[k] = { cons: false, cre: false, mdf: false, sup: false };
//     });
//     setRights(updated);
//   };

//   // 🔹 Réorganiser (reset)
//   const resetRights = () => {
//     setRights({});
//   };

//   // 🔹 Filtrage
//   const filteredData = Array.isArray(ligdroits)
//     ? ligdroits.filter((d) => {
//         return (
//           (!groupe || d.codgrp?.includes(groupe)) &&
//           (!dossier || d.coddos?.includes(dossier))
//         );
//       })
//     : [];

//   return (
//     <div className="acces-container">
//       <h3><Feuille des Accès></h3>

//       {/* 🔹 FILTRES */}
//       <div
//   style={{
//     display: "flex",
//     gap: "15px",
//     marginBottom: "10px",
//     alignItems: "flex-end",
//   }}
// >
//         <div>
//           <label>Groupe</label>
//           <input
//             type="text"
//             value={groupe}
//             onChange={(e) => setGroupe(e.target.value)}
//           />
//         </div>

//         <div>
//           <label>Dossier</label>
//           <input
//             type="text"
//             value={dossier}
//             onChange={(e) => setDossier(e.target.value)}
//           />
//         </div>

//         <button className="btn primary">Confirmer</button>
//         <button className="btn danger">Fermer</button>
//       </div>

//       {/* 🔹 TABLE */}
//       <div className="table-wrapper">
//         <table className="acces-table">
//           <Header />
//           <tbody>
//             {filteredData.length > 0 ? (
//               filteredData.map((d) => (
//                 <Row
//                   key={d.coddr}
//                   code={d.coddr}
//                   label={d.lib || d.coddr}
//                   rights={rights}
//                   toggle={toggle}
//                 />
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="5">❌ Aucune donnée</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* 🔹 ACTIONS */}
//       <div className="actions">
//         <button onClick={checkAll} className="btn success">
//           Cocher Tous 
//         </button>

//         <button onClick={uncheckAll} className="btn warning">
//           Décocher Tous 
//         </button>

//         <button onClick={resetRights} className="btn info">
//           Réorganiser Tous 
//         </button>

//         {/* <button className="btn primary">Ajouter Accès</button> */}
//       </div>
//     </div>
//   );
// };

// // 🔹 Redux
// const mapStateToProps = (state) => ({
//   ligdroits: state.ligdroits?.data || state.ligdroits || [],
//   ConfigDossier: state.ConfigDossier,
// });

// const mapDispatchToProps = (dispatch) => ({
//   SelectLigDroits: (a, b, c, d, e) =>
//     dispatch(SelectLigDroits(a, b, c, d, e)),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(UserAcces);